import React, { useState } from "react";
import { SocialPostReplies } from "./SocialPostReplies";
import { SocialPosts } from "./SocialPosts";

export const SocialPostsTab = ({ details, profileId }) => {
  const [selectedPost, setSelectedPost] = useState(null);

  return selectedPost ? (
    <SocialPostReplies post={selectedPost} selectPost={setSelectedPost}/>
  ) : (
    <SocialPosts details={details} profileId={profileId} selectPost={setSelectedPost}/>
  );
};
